<script setup>
import { reactive, watch } from 'vue'

const props = defineProps({
    node: Object,
})

const emit = defineEmits(['update:config'])

const form = reactive({
    amount: props.node?.data?.config?.amount ?? 1,
    unit: props.node?.data?.config?.unit ?? 'hours',
})

watch(() => props.node, (node) => {
    if (!node) return
    form.amount = node.data?.config?.amount ?? 1
    form.unit = node.data?.config?.unit ?? 'hours'
})

function emitUpdate() {
    emit('update:config', { amount: Number(form.amount), unit: form.unit })
}
</script>

<template>
    <div class="config-panel__section">
        <label class="config-panel__label">Wait Duration</label>
        <div class="delay-config__row">
            <input
                v-model="form.amount"
                class="config-panel__input"
                type="number"
                min="1"
                placeholder="1"
                @input="emitUpdate"
                style="flex: 1"
            />
            <select v-model="form.unit" class="config-panel__select" @change="emitUpdate" style="flex: 1">
                <option value="hours">Hours</option>
                <option value="days">Days</option>
                <option value="weeks">Weeks</option>
            </select>
        </div>
    </div>
</template>

<style scoped>
.delay-config__row {
    display: flex;
    gap: 8px;
    align-items: center;
}
</style>
